// extracted by mini-css-extract-plugin
export var layoutContainer = "_3x-0";
export var layoutContainerOpen = "_3x-5";
export var layoutContainerResizing = "_3x-1";
export var mainContent = "_3x-2";
export var resizeDivider = "_3x-3";
export var slidePanel = "_3x-4";